import { AccordionText } from '@boi/core/lib';
import React from 'react';

import { ExternalLink } from '../../components/ExternalLink/ExternalLink';
import { commonFormStylesIdentifier } from '../../constants';
import { dataPrivacyHomeUrl } from '../../constants/externalLinks';

const className = 'c-MarketingConsentForm';
const AnalyzeTransaction = () => {
  return (
    <>
      <AccordionText
        label="Show me examples"
        labelColor="inherit"
        openLabel="Show less"
        underline
        inverted
      >
        <div
          className={`${className}__readMoreContent ${commonFormStylesIdentifier}__infoText`}
        >
          <div className={`${className}--spaceBellow`}>
            <span>
              Examples for instance could include regular monthly deposits.
              These may identify you as someone who could be interested in a
              particular savings product. Similarly, when you draw down your
              Bank of Ireland mortgage, home insurance is an important
              consideration.
            </span>
          </div>

          <div className={`${className}--spaceBellow`}>
            Read our{' '}
            <ExternalLink url={dataPrivacyHomeUrl} text="Data Privacy Notice" />{' '}
            which describes how we process personal information, and why.
          </div>
        </div>
      </AccordionText>
    </>
  );
};

export default AnalyzeTransaction;
